import axios from "axios";

export const getDistanceBetweenPlaces = async (
  origin: string,
  destination: string
) => {
  try {
    const endpoint =
      "https://6yjguiuy68.execute-api.ap-south-1.amazonaws.com/dev/distance";
    const { data } = await axios.post(endpoint, {
      origin,
      destination,
    });

    const [elements] = data.data.rows;
    const [distanceAndDuration] = elements.elements;

    const { distance, duration } = distanceAndDuration;
    return { distance, duration };
  } catch (error) {
    console.log("getDistanceBetweenPlaces:", error);
  }
};

export const getPlaceDetails = async (placeId: string) => {
  try {
    const endpoint = `https://6yjguiuy68.execute-api.ap-south-1.amazonaws.com/dev/cordinates`;
    const { data } = await axios.get(endpoint, {
      params: {
        place: placeId,
      },
    });

    return data.data.result.geometry.location;
  } catch (error) {
    console.log("Error getPlaceDetails: ", error);
    throw error;
  }
};
